__webpack_public_path__ = `${window.platformBaseURL}/assembler-assets${window.assemblerDebugPath}/`;

import '../styles/aem.min.css';
import '../styles/assembler.css';
import '../styles/loader.css';

import './assembler-server';
